var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBusinessTrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.052 0H28.578C29.8412 0 31.0527 0.501814 31.9459 1.39505C32.8392 2.28829 33.341 3.49977 33.341 4.763V9.526H42.867C44.1302 9.526 45.3417 10.0278 46.2349 10.9211C47.1282 11.8143 47.63 13.0258 47.63 14.289V40.4855C47.63 41.7487 47.1282 42.9602 46.2349 43.8534C45.3417 44.7467 44.1302 45.2485 42.867 45.2485H4.763C3.49977 45.2485 2.28829 44.7467 1.39505 43.8534C0.501814 42.9602 0 41.7487 0 40.4855V14.289C0 11.6455 2.11953 9.526 4.763 9.526H14.289V4.763C14.289 2.11953 16.4085 0 19.052 0ZM28.578 9.526V4.763H19.052V9.526H28.578Z",
    fill: "#4CBDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBusinessTrip);
export default __webpack_public_path__ + "static/media/ic_business_trip.bc41be083121e1d0f60d9ffd057338e1.svg";
export { ForwardRef as ReactComponent };